<!--~
  ~ Copyright (c) 2010-2022 California CAD Solutions, Inc. Licensed subject
  ~ to an End-User License Agreement included in a separate file named EULA.txt
  ~ that is distributed with this file.
  -->
<mat-toolbar color='primary'>
    <h2>Password Reset</h2>
</mat-toolbar>
<mat-dialog-content>
    <div *ngIf="message !== ''" class='reset-password-alert'>{{message}}</div>
    <dash-gis-change-password-form [username]="username"
                             (formSubmit)='changePassword($event)'
                             (formCancel)='close()'></dash-gis-change-password-form>
</mat-dialog-content>
